<template>
    <div>
        <div class="update">
            <p class="update__title">
                {{ update.title }}
            </p>

            <p class="update__body">
                {{ update.body }}
            </p>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['update']
    }
</script>

<style scoped lang="scss">

    .update {

        border-top: 1px dashed #e6e6e6;
        padding-top: 1rem;
        margin: 1rem 0;
        &__title{
            font-weight: 500;
        }
        &__body {
            margin-bottom: 5px;
        }
    }
</style>